import { Button } from '@mui/material';
import { chip } from './styles';
import { formatDate } from 'utils';

export const ERRORS_DATA = [
  {
    id: 1,
    errorID: '001',
    transactionID: '5648256326',
    errorDescription: 'Missing Payment Date',
    dateDetected: '25-05-24',
    status: 'Pending',
    comments: 'N/A',
  },
  {
    id: 2,
    errorID: '001',
    transactionID: '5648256326',
    errorDescription: 'Missing Payment Date',
    dateDetected: '25-05-24',
    status: 'Approved',
    comments: 'N/A',
  },
  {
    id: 3,
    errorID: '001',
    transactionID: '5648256326',
    errorDescription: 'Missing Payment Date',
    dateDetected: '25-05-24',
    status: 'Pending',
    comments: 'N/A',
  },
  {
    id: 4,
    errorID: '001',
    transactionID: '5648256326',
    errorDescription: 'Missing Payment Date',
    dateDetected: '25-05-24',
    status: 'Approved',
    comments: 'N/A',
  },
  {
    id: 5,
    errorID: '001',
    transactionID: '5648256326',
    errorDescription: 'Missing Payment Date',
    dateDetected: '25-05-24',
    status: 'Pending',
    comments: 'N/A',
  },
  {
    id: 6,
    errorID: '001',
    transactionID: '5648256326',
    errorDescription: 'Missing Payment Date',
    dateDetected: '25-05-24',
    status: 'Approved',
    comments: 'N/A',
  },
  {
    id: 7,
    errorID: '001',
    transactionID: '5648256326',
    errorDescription: 'Missing Payment Date',
    dateDetected: '25-05-24',
    status: 'Pending',
    comments: 'N/A',
  },
  {
    id: 8,
    errorID: '001',
    transactionID: '5648256326',
    errorDescription: 'Missing Payment Date',
    dateDetected: '25-05-24',
    status: 'Approved',
    comments: 'N/A',
  },
];

export const ERRORS_COLUMNS = [
  { headerName: 'Error ID', field: 'id' },
  { headerName: 'Transaction ID', field: 'transactionID' },
  { headerName: 'Error Description', field: 'errorDescription' },
  {
    headerName: 'Date Detected',
    field: 'date',
    renderCell: params => {
      return formatDate(params?.date);
    },
  },
  {
    headerName: 'Status',
    field: 'status',
    renderCell: row => (
      <Button variant="outlined" size="small" sx={chip(row)}>
        {row?.status}
      </Button>
    ),
  },
  { headerName: 'Comment', field: 'comment' },
  {
    headerName: 'Cashmatch ID',
    field: 'cashMatchId',
    renderCell: params => {
      return params?.SalesDatum?.cashMatchId;
    },
  },
  {
    headerName: 'Gross FCI',
    field: 'grossFCI',
    renderCell: params => {
      return params?.SalesDatum?.grossFCI;
    },
  },
  {
    headerName: 'FCI Recognition',
    field: 'FCIRecognition',
    renderCell: params => {
      return params?.SalesDatum?.FCIRecognition;
    },
  },
  {
    headerName: 'Percentage Payable',
    field: 'percentagePayable',
    renderCell: params => {
      return params?.SalesDatum?.percentagePayable;
    },
  },
  {
    headerName: 'Payable',
    field: 'payable',
    renderCell: params => {
      return params?.SalesDatum?.payable;
    },
  },
];

export const VALIDATIONS_DATA = [
  {
    id: 1,
    transactionID: '5648256326',
    date: '25-05-24',
    clientName: 'William',
    productService: 'Pension',
    salesAmount: '£120.00',
    commissionRate: '20%',
    grossCommission: '£17.00',
    idRef: 'KP374',
    grossFCI: '£110.00',
  },
  {
    id: 2,
    transactionID: '5648256326',
    date: '25-05-24',
    clientName: 'William',
    productService: 'Pension',
    salesAmount: '£120.00',
    commissionRate: '20%',
    grossCommission: '£17.00',
    idRef: 'KP374',
    grossFCI: '£110.00',
  },
  {
    id: 3,
    transactionID: '5648256326',
    date: '25-05-24',
    clientName: 'William',
    productService: 'Pension',
    salesAmount: '£120.00',
    commissionRate: '20%',
    grossCommission: '£17.00',
    idRef: 'KP374',
    grossFCI: '£110.00',
  },
  {
    id: 4,
    transactionID: '5648256326',
    date: '25-05-24',
    clientName: 'William',
    productService: 'Pension',
    salesAmount: '£120.00',
    commissionRate: '20%',
    grossCommission: '£17.00',
    idRef: 'KP374',
    grossFCI: '£110.00',
  },
  {
    id: 5,
    transactionID: '5648256326',
    date: '25-05-24',
    clientName: 'William',
    productService: 'Pension',
    salesAmount: '£120.00',
    commissionRate: '20%',
    grossCommission: '£17.00',
    idRef: 'KP374',
    grossFCI: '£110.00',
  },
  {
    id: 6,
    transactionID: '5648256326',
    date: '25-05-24',
    clientName: 'William',
    productService: 'Pension',
    salesAmount: '£120.00',
    commissionRate: '20%',
    grossCommission: '£17.00',
    idRef: 'KP374',
    grossFCI: '£110.00',
  },
  {
    id: 7,
    transactionID: '5648256326',
    date: '25-05-24',
    clientName: 'William',
    productService: 'Pension',
    salesAmount: '£120.00',
    commissionRate: '20%',
    grossCommission: '£17.00',
    idRef: 'KP374',
    grossFCI: '£110.00',
  },
  {
    id: 8,
    transactionID: '5648256326',
    date: '25-05-24',
    clientName: 'William',
    productService: 'Pension',
    salesAmount: '£120.00',
    commissionRate: '20%',
    grossCommission: '£17.00',
    idRef: 'KP374',
    grossFCI: '£110.00',
  },
];

export const VALIDATIONS_COLUMNS = [
  { headerName: 'Transaction ID', field: 'transactionID' },
  { headerName: 'Date', field: 'date' },
  { headerName: 'Client Name', field: 'clientName' },
  { headerName: 'Product / Service', field: 'productService' },
  { headerName: 'Commission Amount', field: 'salesAmount' },
  { headerName: 'Commission Rate', field: 'commissionRate' },
  { headerName: 'Gross Commission', field: 'grossCommission' },
  { headerName: 'IDRef', field: 'idRef' },
  { headerName: 'Gross FCI', field: 'grossFCI' },
];
